import React, { useState } from 'react';
import { ChevronsLeftRight } from 'lucide-react';

const ImageComparison = ({ beforeImage, afterImage, beforeLabel, afterLabel }) => {
    const [sliderValue, setSliderValue] = useState(50);

    const handleSliderChange = (e) => {
        setSliderValue(e.target.value);
    };

    return (
        <div className="relative h-[500px] w-full rounded-2xl overflow-hidden shadow-2xl cursor-ew-resize group">
            {/* After Image (Background) */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url('${afterImage}')` }}
            >
                <div className="absolute top-6 right-6 bg-black/70 text-white px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest">
                    {afterLabel}
                </div>
            </div>

            {/* Before Image (Overlay) */}
            <div
                className="absolute inset-0 bg-cover bg-center border-r-4 border-white"
                style={{
                    backgroundImage: `url('${beforeImage}')`,
                    width: `${sliderValue}%`
                }}
            >
                <div className="absolute top-6 left-6 bg-white/90 text-black px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest">
                    {beforeLabel}
                </div>
            </div>

            {/* Slider Input */}
            <input
                type="range"
                min="0"
                max="100"
                value={sliderValue}
                onChange={handleSliderChange}
                className="comparison-slider-thumb absolute top-0 left-0 w-full h-full opacity-0 z-20 cursor-ew-resize"
            />

            {/* Handle Icon */}
            <div
                className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center pointer-events-none z-30"
                style={{ left: `${sliderValue}%` }}
            >
                <ChevronsLeftRight className="w-6 h-6 text-gray-800" />
            </div>
        </div>
    );
};

export default ImageComparison;
